import React, { useState, useEffect } from "react";
import { DatePicker, ConfigProvider } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";

dayjs.extend(customParseFormat);
dayjs.extend(localeData);

const EditableDateInput = ({
  name,
  value,
  onChange,
  disabled = false,
  className = "w-full p-2",
  placeholder = "",
}) => {
  const [dateValue, setDateValue] = useState(null);

  const dateFormat = "DD/MM/YYYY";

  useEffect(() => {
    if (value) {
      try {
        const parsedDate = dayjs(value, "YYYY-MM-DD", true);

        if (parsedDate.isValid()) {
          setDateValue(parsedDate);
        } else {
          const altParsedDate = dayjs(value, dateFormat, true);

          if (altParsedDate.isValid()) {
            setDateValue(altParsedDate);
          } else {
            const genericParsedDate = dayjs(value);
            setDateValue(
              genericParsedDate.isValid() ? genericParsedDate : null
            );
          }
        }
      } catch (error) {
        console.error("Error parsing date:", error);
        setDateValue(null);
      }
    } else {
      setDateValue(null);
    }
  }, [value]);

  const handleDateChange = (date, dateString) => {
    if (!date) {
      onChange({
        target: {
          name: name,
          value: "",
        },
      });
      return;
    }

    const formattedDate = date.format("YYYY-MM-DD");

    onChange({
      target: {
        name: name,
        value: formattedDate,
      },
    });
  };

  const customDateRender = (current, today) => {
    return (
      <div className="ant-picker-cell-inner">
        {current ? current.date() : ""}
      </div>
    );
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          DatePicker: {
            paddingInline: 8,
            colorTextDisabled: "#111",
          },
        },
      }}
    >
      <DatePicker
        value={dateValue}
        onChange={handleDateChange}
        format={dateFormat}
        inputReadOnly={false}
        disabled={disabled}
        className={className}
        placeholder={placeholder}
        style={{ width: "100%", color: "#111" }}
        allowClear={true}
        onBlur={(e) => {
          const inputValue = e.target.value;

          if (!inputValue || dateValue) return;

          const parsedDate = dayjs(inputValue, dateFormat, true);
          if (parsedDate.isValid()) {
            handleDateChange(parsedDate, inputValue);
          }
        }}
      />
    </ConfigProvider>
  );
};

export default EditableDateInput;
